import { Component, DoCheck } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { fadeAnimationQuick } from '../../../animations/animations';
import { AppStateService } from '../../common/services/app-state/app-state.service';
import { ContextButtonService } from '../../common/services/context-button/context-button.service';
import { filter } from 'rxjs/operators';
import { ActionButton } from '../../common/types/action-button';

@Component({
    selector: 'cas-side-menu-button',
    templateUrl: './side-menu-button.component.html',
    styleUrls: ['./side-menu-button.component.scss'],
    animations: [
        fadeAnimationQuick
    ]
})
export class SideMenuButtonComponent implements DoCheck {

    public isCloseButton = false;
    public isBackEnabled = false;
    public isCustomBackEnabled = false;
    public customBackButton: ActionButton;

    constructor(
        private router: Router,
        private appStateService: AppStateService,
        private contextButtonService: ContextButtonService) {
        router.events
            .pipe(filter(event => event instanceof NavigationStart))
            .subscribe(() => this.contextButtonService.isBackEnabled = false);
    }

    public ngDoCheck() {
        if (this.contextButtonService) {
            if (this.contextButtonService.isCloseButton !== this.isCloseButton) {
                this.isCloseButton = this.contextButtonService.isCloseButton;
            }

            if (this.contextButtonService.isBackEnabled !== this.isBackEnabled) {
                this.isBackEnabled = this.contextButtonService.isBackEnabled;
            }

            if (this.contextButtonService.isCustomBackEnabled !== this.isCustomBackEnabled) {
                this.isCustomBackEnabled = this.contextButtonService.isCustomBackEnabled;
            }

            if (this.contextButtonService.customBackButton !== this.customBackButton) {
                this.customBackButton = this.contextButtonService.customBackButton;
            }

        }
    }

    public hideToolbars(): boolean {
        return this.isLogin() || this.contextButtonService.toolbarHidden;
    }

    public isDesktop() {
        return this.appStateService.isDesktop;
    }

    public isLogin() {
        return this.router.url === '/login';
    }

    public isSettings() {
        return this.router.url === '/settings';
    }

    public toggleOpen() {
        this.appStateService.isSideNavOpened = !this.appStateService.isSideNavOpened;
    }

    public goBack() {
        this.contextButtonService.goBack();
    }

}
